(function() {
    'use strict';

    angular
        .module('app')
        .controller('CreateReviewController', CreateReviewController);

    CreateReviewController.$inject = ['$http', '$state', 'authenticator'];

    function CreateReviewController($http, $state, authenticator) {
        var createReview = this;
        createReview.$onInit = init;
        createReview.canReview = canReview;
        createReview.openReview = openReview;

        function init(){
            createReview.recent_concerts = [];
            createReview.object_type = createReview.objectType;
            createReview.object_slug = createReview.objectSlug;

            getRecentConcerts();
            checkLoggedIn();
        }

        function getRecentConcerts(){
            return $http.get('/app/api/concerts/me/'+createReview.object_type+'/'+createReview.object_slug)
                .then(function(response){
                    createReview.recent_concerts = response.data;
                });
        }

        function openReview(){
            if(canReview()){
                $state.go('review', {'concert_slug': createReview.recent_concerts[0].concert_slug})
            }
        }

        function canReview(){
            return createReview.logged_in && createReview.recent_concerts.length > 0;
        }

        function checkLoggedIn() { //Checks whether the current user is logged-in and changes the header based on this
            return authenticator.checkLoginStatus()
                .then(function (loggedIn) {
                    createReview.logged_in = loggedIn;
                    return createReview.logged_in;
                });
        }
    }
})();
